// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@riseart/common';
import { GridFluidIcon, FullScreenIcon } from '@riseart/icons';
import { GridViewSwitch } from '@riseart/grid';

type Props = {
  listUrl?: string | null,
  detailUrl?: string | null,
};

/**
 * ArtGallerySwitcher
 */
export const ArtGallerySwitcher = ({ listUrl, detailUrl }: Props): Node => {
  if (!listUrl && !detailUrl) {
    return null;
  }

  return (
    <GridViewSwitch>
      {listUrl ? (
        <FormattedMessage id="components.art.gridView">
          {(text: string) => (
            <Link obfuscate rel="nofollow" type="light" to={listUrl} title={text}>
              <GridFluidIcon />
              <span>{text}</span>
            </Link>
          )}
        </FormattedMessage>
      ) : null}

      {detailUrl ? (
        <FormattedMessage id="components.art.detailsView">
          {(text: string) => (
            <Link obfuscate rel="nofollow" type="light" to={detailUrl} title={text}>
              <FullScreenIcon />
              <span>{text}</span>
            </Link>
          )}
        </FormattedMessage>
      ) : null}
    </GridViewSwitch>
  );
};
